import { CheckCircleOutlineOutlined, ErrorOutlineOutlined } from "@mui/icons-material";
import { Box, Chip, CircularProgress, FormControlLabel, Grid, Switch, Tooltip } from "@mui/material";
import requests from "api/requests";
import { useEffect, useState } from "react";
import { IATPDriverRequestSettings, IATPDriverRequestUserSettings } from "./types";

interface IProps {
  atpID: number;
  onChanged: () => void;
}
const userSettingsKey = "atp-driver-request"

export default function NeedDriverControl(props: IProps) {
  const {
    atpID,
    onChanged,
  } = props;

  const [settings, setSettings] = useState<IATPDriverRequestSettings | null>(null);
  const [userSettings, setUserSettings] = useState<IATPDriverRequestUserSettings | null>(null);

  useEffect(() => {
    requests.get(`/atp/atp/${atpID}/driver-request-settings/`).then((r) => setSettings(r.body))
  }, [atpID])

  useEffect(() => {
    requests.get(`/user/settings/${userSettingsKey}/`).then((r) => setUserSettings(r.body))
  }, [])

  const saveNeedDrivers = (is_need_drivers: boolean) => {
    requests.patch(`/atp/atp/${atpID}/driver-request-settings/`, {
      is_need_drivers: is_need_drivers
    }).then(() => {
      setSettings((o) => {
        if (!o) return o;
        return {
          ...o,
          is_need_drivers: is_need_drivers
        }
      })
      onChanged();
    })
  }

  const saveUserSettings = (_settings: IATPDriverRequestUserSettings) => {
    requests.put(`/user/settings/${userSettingsKey}/`, _settings).then((r) => {
      setUserSettings(_settings);
    })
  }

  if (!settings || !userSettings) {
    return <CircularProgress size={30} />
  }

  return (
    <Grid container spacing={2} alignItems={"center"}>
      <Grid item xs={12} md={"auto"}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'start',
          flexWrap: 'wrap',
          '& > *': {
            margin: 0.5,
          },
        }}>
          {settings.is_need_drivers ? (
            <Chip label="Увімкнено" color="success" icon={<CheckCircleOutlineOutlined />} />
          ) : (
            <Chip label="Вимкнено" color="warning" icon={<ErrorOutlineOutlined />} />
          )}
          {!settings.available && (
            <Chip label="Нові заявки поки недоступні" color="error" icon={<ErrorOutlineOutlined />} />
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={"auto"}>
        <FormControlLabel control={(
          <Switch
            checked={settings.is_need_drivers}
            onChange={(_, _checked) => saveNeedDrivers(_checked)}
          />
        )} label="Набір водіїв" />
      </Grid>
      {!!settings.is_need_drivers && (
        <Grid item xs={12} md={"auto"}>
          <Tooltip title="Надсилати сповіщення про нові заявки на пошута та в Push-повідомленні.">
            <FormControlLabel control={(
              <Switch
                checked={!userSettings.disable_notification}
                onChange={(_, _checked) => saveUserSettings({
                  ...userSettings,
                  disable_notification: !_checked
                })}
              />
            )} label="Сповіщення" />
          </Tooltip>
        </Grid>
      )}
    </Grid>
  )
}